export const ACCOUNT_THEME_IDS = [
  'theme-red',
  'theme-blue',
  'theme-monochrome',
  'theme-teal',
  'theme-green',
  'theme-deep-green',
  'theme-orange',
  'theme-blue-grey',
  'theme-purple',
  'theme-indigo',
  'theme-tangaroa',
  'theme-white',
] as const;

export type AccountThemeId = (typeof ACCOUNT_THEME_IDS)[number];

export const DEFAULT_ACCOUNT_THEME: AccountThemeId = 'theme-blue';

export function isAccountThemeId(value: string): value is AccountThemeId {
  return ACCOUNT_THEME_IDS.includes(value as AccountThemeId);
}

export function normalizeAccountThemeId(
  value: string | undefined | null,
): AccountThemeId {
  if (value && isAccountThemeId(value)) {
    return value;
  }

  return DEFAULT_ACCOUNT_THEME;
}
